import styles from './FooterSecondaryNavMobile.module.scss';

import React, { FC } from 'react';
import type { LinkSet } from 'api/contentful/contentTypes.cloverdotcom';
import { SimpleArrowAccordionV2 } from 'components/Accordion/SimpleArrowAccordionV2/SimpleArrowAccordionV2';
import type { IAccordionItem } from 'components/Accordion/models';
import { Grid } from 'components/Grid/Grid';
import type { FlatEntry } from 'services/cms/flattenContentful';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { FooterLinkSet } from '../FooterLinkSet/FooterLinkSet';

const makeAccordionSections = (entries: Array<FlatEntry<LinkSet>>): IAccordionItem[] =>
  entries.map((entry, index) => ({
    id: componentKeyV2(entry, index),
    title: entry.title,
    body: (
      <FooterLinkSet
        entry={{ items: entry.items }}
        listClassName={styles.list}
        listItemClassName={styles.listItem}
        titleClassName={styles.title}
      />
    ),
  }));

interface IFooterSecondaryNavMobileProps {
  items?: Array<FlatEntry<LinkSet>>;
}

export const FooterSecondaryNavMobile: FC<IFooterSecondaryNavMobileProps> = ({ items = [] }) => {
  if (!items || items.length === 0) return null;

  return (
    <Grid item xs={12}>
      <div className={styles.accordion}>
        <SimpleArrowAccordionV2
          bodyClassName={styles.accordionBody}
          items={makeAccordionSections(items)}
          isFooter
        />
      </div>
    </Grid>
  );
};
